module.exports = __webpack_public_path__ + "static/media/Background_Modern_2x.5db53eab.png";